import React, { useState } from 'react';
import PackerDeliveryOrderBatchOrder from './packerDeliveryOrderBatchOrder';
import PackerRefunds from './packerRefunds';

const PackerRouteRowFilteredDelivery = ({ delivery, customPackingType }) => {
  const [packedItemIds, setPackedItemIds] = useState([]);
  const [refundOrderItems, setRefundOrderItems] = useState([]);

  const addRefundOrderItems = (itemsToAdd) => {
    const newRefundOrderItems = [...refundOrderItems].concat(itemsToAdd);
    setRefundOrderItems(newRefundOrderItems);
  };

  const removeRefundOrderItemFromIndex = (index) => {
    const newRefundOrderItems = [...refundOrderItems];
    newRefundOrderItems.splice(index, 1);
    setRefundOrderItems(newRefundOrderItems);
  };

  const addPackedItem = (packedItem) => {
    const newPackedItemIds = packedItemIds.slice();
    newPackedItemIds.push(packedItem);
    setPackedItemIds(newPackedItemIds);
  };

  const removePackedItemFromIndex = (index) => {
    const newPackedItemIds = packedItemIds.slice();
    newPackedItemIds.splice(index, 1);
    setPackedItemIds(newPackedItemIds);
  };

  const updateRefundOrderItem = (newRoi, index) => {
    const newRefundOrderItems = [...refundOrderItems];

    // currently you can only change the payer on the orderId level, not per each item
    if (newRoi.payer !== newRefundOrderItems[index].payer) {
      newRefundOrderItems.forEach((roi) => (roi.orderId === newRoi.orderId ? (roi.payer = newRoi.payer) : null));
    }

    newRefundOrderItems[index] = newRoi;
    setRefundOrderItems(newRefundOrderItems);
  };

  const filteredOrders = delivery.deliveryOrderBatch.orders.filter((order) =>
    order.items.some((oi) => oi.item.customPackingType === customPackingType)
  );

  const refunds = delivery.deliveryOrderBatch.orders
    .map((o) => (o.payment ? o.payment.refunds : []))
    .flat()
    .filter((refund, index, self) => self.findIndex((existingValue) => existingValue.id === refund.id) === index);

  return (
    <div className="packer-block m-b-3" key={delivery.id}>
      <h4 className="m-b-3">{delivery.name}</h4>

      {filteredOrders.map((order) => {
        const filteredItems = order.items.filter((oi) => oi.item.customPackingType === customPackingType);

        const isPacked = filteredItems.every((oi) =>
          packedItemIds.some((packedItemId) => oi.item.id === packedItemId.itemId && order.id === packedItemId.orderId)
        );

        return (
          <div className="m-b-2">
            <PackerDeliveryOrderBatchOrder
              key={order.id}
              order={order}
              orderItemsForPacking={filteredItems}
              isPacked={isPacked}
              packedItemIds={packedItemIds}
              addPackedItem={addPackedItem}
              removePackedItemFromIndex={removePackedItemFromIndex}
              refundOrderItems={refundOrderItems}
              addRefundOrderItems={addRefundOrderItems}
              removeRefundOrderItem={removeRefundOrderItemFromIndex}
            />
          </div>
        );
      })}

      {refundOrderItems.length || refunds.length ? (
        <>
          <hr />

          <PackerRefunds
            refundOrderItems={refundOrderItems}
            setRefundOrderItems={setRefundOrderItems}
            removeFromRefunds={removeRefundOrderItemFromIndex}
            updateRefundOrderItem={updateRefundOrderItem}
            orderBatchId={filteredOrders.batchId}
            user={delivery.deliveryOrderBatch.user}
            refunds={refunds}
            invalidateQueryKey={'routes'}
          />
        </>
      ) : (
        ''
      )}
    </div>
  );
};

export default PackerRouteRowFilteredDelivery;
